// name of module store
export const STORE_MODULE_CLIENT_DEPOSITS_CREATION = 'client-deposits-creation';
